import React from "react"
import { Link } from "gatsby"

const NextStoryLink = ({eyebrow, nextLink}) => {
    return (
        <div className="next-story-link">
            <div className="row">
                <div className="eyebrow">{eyebrow}</div>
            </div>
            <Link to={nextLink.url}>
                <div className="row">
                    <h2 className="hero-headline">{nextLink.title}</h2>
                    <div className="arrow"><span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78 60" fill="none">
                            <path d="M77.6562 30.0342C77.6562 29.7437 77.5732 29.5361 77.3657 29.3286L49.1846 0.856934C48.6035 0.234375 48.2715 0.109863 47.981 0.109863C47.3584 0.109863 46.9849 0.566406 46.9849 1.06445C46.9849 1.39648 47.0264 1.64551 47.2339 1.85303L65.9521 20.5713L74.585 29.1626L65.8691 29.0796H1.53809C1.04004 29.0796 0.583496 29.4946 0.583496 30.0342C0.583496 30.5737 1.04004 30.9888 1.53809 30.9888H65.8691L74.585 30.9058L65.9521 39.4971L47.2339 58.2153C47.0679 58.3813 46.9849 58.6719 46.9849 58.9624C46.9849 59.4604 47.3584 59.917 47.981 59.917C48.2715 59.917 48.479 59.834 48.6865 59.6265L77.3657 30.7397C77.5732 30.5322 77.6562 30.3247 77.6562 30.0342Z" fill="white"/>
                        </svg></span>
                    </div>
                </div>

            </Link>
        </div>
    )
}

export default NextStoryLink